"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBookInteriorPageCount;
const Product_1 = require("../../models/Product");
function getBookInteriorPageCount(projectGroups, hammerCategory) {
  if (!(0, Product_1.isABooksCategory)(hammerCategory)) return 0;
  const interiorPrintableGroups = projectGroups.find(pg => pg.type === 'interior');
  let interiorPagesNumber = 0;
  if (interiorPrintableGroups) {
    interiorPagesNumber = (0, Product_1.isSpreadBooksCategory)(hammerCategory) ? interiorPrintableGroups.printables.length * 2 : interiorPrintableGroups.printables.length;
  }
  return interiorPagesNumber;
}